import { UseGQLQueryConfig } from 'hooks/useGQLQuery/useGQLQuery.types';
import { QUERY_continueCalloutDialog } from 'queries';
import { ContinueCalloutDialogQuery, ContinueCalloutDialogQueryVariables } from 'types/graphql';

export const continueCalloutDialogConfig = (
  orderId: number,
): UseGQLQueryConfig<
  ContinueCalloutDialogQuery,
  ContinueCalloutDialogQuery,
  ContinueCalloutDialogQueryVariables
> => {
  return {
    key: 'SHIFT_DISTRIBUTION_FETCH_COMMUNITY_QUERY',
    query: QUERY_continueCalloutDialog,
    variables: {
      orderId,
    },
  };
};
